import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import useAnalytics from 'helpers/useAnalytics';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import SupportCard from 'components/onboarding/SupportCard';
import HelpDocLink from 'atoms/HelpDocLink';

import { HELP_ARTICLE_HOME, HELP_LINKS } from 'components/onboarding/constants';

function DocsCard() {
  const classes = useStyles();
  const analytics = useAnalytics();

  const handleDocumenationClick = (itemName: string) => {
    analytics.track('Documentation Link clicked', {
      category: 'AD - Home',
      label: itemName,
    });
  };

  return (
    <SupportCard title="Documentation">
      <Typography className={classes.p}>
        We want to help you to get connected and start Sifting as soon as possible. Here are some
        articles to help you get started. You can also visit our{' '}
        <Link
          href={HELP_ARTICLE_HOME}
          color="secondary"
          underline="always"
          target="_blank"
          rel="noopener noreferrer"
        >
          Help Center
        </Link>{' '}
        for more.
      </Typography>
      {HELP_LINKS.map((item, i) => (
        <HelpDocLink
          href={item.href}
          key={`help-link-${i}`}
          onClick={() => handleDocumenationClick(item.name)}
        >
          {item.name}
        </HelpDocLink>
      ))}
    </SupportCard>
  );
}

const useStyles = makeStyles(theme => ({
  root: {},
  p: {
    marginBottom: theme.spacing(3),
  },
}));

export default DocsCard;
